/**
 * The symbol that starts a ref on an element. For example, in: "<div #myDiv>", #myDiv would be a valid ref
 * @type {string}
 */
export const REF_QUALIFIER = "$";